import template from './connectCenter.template.html';

export default {
  template,
  controller: class controller {
    constructor($rootScope, authenticationService, eventService, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.CurrentOrganization = null;
      ctrl.CurrentAccount = null;
      ctrl.isMinimized = true;
      ctrl.isConnected = false;
      ctrl.hasSms = false;
      ctrl.hasSmsEvents = false;
      ctrl.hasPhone = false;
      ctrl.hasPhoneEvents = false;
      ctrl.isSuspended = authenticationService.isSuspended();

      ctrl.activeTab = 0;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.CurrentOrganization = $rootScope.CurrentOrganization;
        ctrl.CurrentAccount = $rootScope.CurrentAccount;
        ctrl.isConnected = authenticationService.isAuthenticated();
        ctrl.isSuspended = authenticationService.isSuspended();

        if (!ctrl.isConnected) {
          ctrl.hasSms = false;
          ctrl.hasPhone = false;
        } else {
          ctrl.hasSms = ctrl.isConnected && ctrl.CurrentOrganization.canUseSMS();

          ctrl.hasPhone =
            ctrl.isConnected &&
            ctrl.CurrentOrganization.canUsePhone() &&
            ctrl.CurrentOrganization.getPhonesForOwner(ctrl.CurrentAccount.id) &&
            ctrl.CurrentOrganization.getPhonesForOwner(ctrl.CurrentAccount.id).length;
        }
      };

      /*
       * UI Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.minimize = () => {
        eventService.connectToggle(false);
      };
      ctrl.activateTab = (tab) => {
        ctrl.isMinimized = false;
        if (tab !== undefined) {
          ctrl.activeTab = tab;
        }
        switch (ctrl.activeTab) {
          case 0:
            ctrl.hasSmsEvents = false;
            uiService.elementContentScroll('smsContent');
            break;
          case 1:
            ctrl.hasPhoneEvents = false;
            uiService.elementContentScroll('callContent');
            break;
          default:
            break;
        }
      };

      /*
       * Event Handlers
       * --------------------------------------------------------------------------------
       */
      ctrl.onSms = () => {
        uiService.scopeApply(() => {
          ctrl.hasSmsEvents = 0;
        }, 100);
      };
      ctrl.onCall = (isActive) => {
        eventService.connectEvents(isActive);
        uiService.scopeApply(() => {
          ctrl.hasPhoneEvents = isActive;
        }, 100);
      };

      /*
       * Event Listeners
       * --------------------------------------------------------------------------------
       */
      eventService.onConnectToggle((isActive) => {
        ctrl.isMinimized = !isActive;
      });
      eventService.onCredentialsChanged(() => {
        ctrl.initialize();
      });
      eventService.onConnectOnline((accountsOnline) => {
        ctrl.initialize();
        let expiration = -1;
        if (
          !ctrl.CurrentOrganization.isSubscribed &&
          !ctrl.CurrentOrganization.isTrialExpired()
        ) {
          expiration = ctrl.CurrentOrganization.getTrialExpiresInDays();
        }
        if (expiration >= 0 && expiration <= 7) {
          uiService.toast({
            text: {
              p1: 'WARNING',
              p2: ctrl.CurrentOrganization.getName(),
              p3: `trial will expire in ${expiration} days!`
            },
            warn: true,
            delay: 900000,
            action: 'OK'
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Welcome to',
              p2: ctrl.CurrentOrganization.getName(),
              p3: `there ${accountsOnline === 1 ? 'is' : 'are'} ${
                accountsOnline === 0 ? 'no' : accountsOnline
              } other user(s) online.`
            }
          });
        }
      });
      eventService.onConnectOffline(() => {});
      eventService.onConnectSms(() => {
        ctrl.isMinimized = false;
        ctrl.activateTab(0);
      });
      eventService.onConnectCall(() => {
        ctrl.isMinimized = false;
        ctrl.activateTab(1);
      });
      eventService.onConnectCallReceived(() => {
        ctrl.isMinimized = false;
        ctrl.activateTab(1);
      });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
